module.exports = __webpack_public_path__ + "fonts/3e8f769.ttf";